import ReactDOM from 'react-dom/client';
import App from './App';
import { AppProvider } from './context/AppContext';
import { initSentry, SentryErrorBoundary } from './lib/sentry';
import './i18n';
import './index.css';

// Initialize error monitoring as early as possible so even import-time errors
// downstream get captured. No-op when VITE_SENTRY_DSN is unset or in dev mode.
initSentry();

function FatalError() {
    return (
        <div style={{
            minHeight: '100vh', display: 'grid', placeItems: 'center',
            fontFamily: 'Inter, system-ui, sans-serif', background: '#f8fafc',
            color: '#1a1d2e', padding: '2rem', textAlign: 'center',
        }}>
            <div style={{ maxWidth: 460 }}>
                <h1 style={{ fontFamily: 'Fraunces, Georgia, serif', fontSize: '2rem', margin: 0 }}>
                    Something went wrong.
                </h1>
                <p style={{ color: '#64748b', lineHeight: 1.6, marginTop: 12 }}>
                    The error has been reported automatically. Try refreshing the page —
                    if it keeps happening, drop us a line at contact@rentnova.app.
                </p>
                <button
                    onClick={() => window.location.reload()}
                    style={{
                        marginTop: 24, padding: '0.75rem 1.5rem',
                        background: '#16a34a', color: '#fff', border: 0,
                        borderRadius: 10, fontWeight: 600, cursor: 'pointer',
                    }}
                >
                    Reload
                </button>
            </div>
        </div>
    );
}

ReactDOM.createRoot(document.getElementById('root')!).render(
    <SentryErrorBoundary fallback={<FatalError />} showDialog={false}>
        <AppProvider>
            <App />
        </AppProvider>
    </SentryErrorBoundary>
);
